import React from 'react';
import { motion } from 'framer-motion';
import ReactECharts from 'echarts-for-react';

const Chart = ({ title, data, type = 'line', height = 300, options = {} }) => {
  const getOption = () => {
    const baseOption = {
      title: {
        text: title,
        textStyle: {
          fontSize: 16,
          fontWeight: 600,
          color: '#1e293b'
        }
      },
      tooltip: {
        trigger: 'axis',
        backgroundColor: 'rgba(255, 255, 255, 0.95)',
        borderColor: '#e2e8f0',
        textStyle: {
          color: '#1e293b'
        }
      },
      legend: {
        bottom: 0,
        textStyle: {
          color: '#64748b'
        }
      },
      grid: {
        left: '3%',
        right: '4%',
        bottom: '10%',
        containLabel: true
      },
      xAxis: {
        type: 'category',
        boundaryGap: false,
        data: data.labels || [],
        axisLine: {
          lineStyle: {
            color: '#e2e8f0'
          }
        },
        axisLabel: {
          color: '#64748b'
        }
      },
      yAxis: {
        type: 'value',
        axisLine: {
          lineStyle: {
            color: '#e2e8f0'
          }
        },
        axisLabel: {
          color: '#64748b'
        },
        splitLine: {
          lineStyle: {
            color: '#f1f5f9'
          }
        }
      },
      series: data.series || []
    };

    return { ...baseOption, ...options };
  };

  return (
    <motion.div 
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
      className="bg-white rounded-xl shadow-sm border border-secondary-200 p-6"
    >
      <ReactECharts 
        option={getOption()} 
        style={{ height: `${height}px` }}
        opts={{ renderer: 'svg' }}
      />
    </motion.div>
  );
};

export default Chart;